import * as React from "react";
import { Zap } from "lucide-react";
import { cn } from "@/lib/utils";

type Props = {
  className?: string;
  size?: "xs" | "sm" | "md" | "lg";
};

export const SuperPageIcon: React.FC<Props> = ({ className, size = "md" }) => {
  const sizeMap = {
    xs: "size-6 p-1 shadow-sm",
    sm: "size-7 p-1 shadow-md",
    md: "size-8 p-2 shadow-lg",
    lg: "size-12 p-3 shadow-lg",
  };
  return <Zap className={cn(sizeMap[size], "bg-sky-600 rounded-full text-amber-300 fill-amber-300", className)} />;
};
